<template>
  <v-container>
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon>fas fa-comment-dots</v-icon>
        <span class="title ml-2">Mensajes</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-btn color="primary" @click="showAdd = true">Agregar</v-btn>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="mensajes"
          hide-default-footer
          :items-per-page="25"
        >
          <template v-slot:item.opciones="{ item }">
            <v-btn small fav text color="primary" @click="editMensaje(item.id)" class="ml-2">
              <v-icon>fas fa-edit</v-icon>
            </v-btn>
            <v-btn small fav text color="error" @click="deleteMensaje(item.id)">
              <v-icon>fas fa-trash</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <v-pagination
          v-model="page"
          :length="pages"
        ></v-pagination>
      </v-card-text>
    </v-card>
    <!-- =================================================================== -->
    <!-- Dialogs -->
    <!-- =================================================================== -->
    <v-dialog v-model="showAdd" max-width="500px">
      <EditMensaje
        @close="showAdd = false"
        @saved="refresh()"
      ></EditMensaje>
    </v-dialog>
    <v-dialog v-model="showEdit" max-width="500px">
      <EditMensaje
        v-model="selected"
        :update="true"
        @close="showEdit = false"
        @saved="refresh()"
      ></EditMensaje>
    </v-dialog>
  </v-container>
</template>

<script>
import dayjs from 'dayjs'
import EditMensaje from '../components/EditMensaje'
export default {
  data () {
    return {
      mensajes: [],
      headers: [
        { text: 'Título', value: 'titulo', sortable: false },
        { text: 'Mensaje', value: 'mensaje', sortable: false },
        { text: 'Fecha inicio', value: 'inicio', sortable: false },
        { text: 'Fecha final', value: 'fin', sortable: false },
        { text: 'Opciones', value: 'opciones', sortable: false }
      ],
      page: 1,
      pages: 1,
      selected: {
        titulo: '',
        mensaje: '',
        fecha_inicio: '',
        fecha_fin: ''
      },
      showAdd: false,
      showEdit: false
    }
  },
  components: {
    EditMensaje
  },
  async created () {
    await this.getPages()
    await this.getMensajes()
  },
  methods: {
    async getPages () {
      const { data } = await this.$http.mensajes.get('/count')
      this.pages = Math.ceil(data / 25)
    },
    async getMensajes () {
      const page = (this.page - 1) * 25
      const { data } = await this.$http.mensajes.get(`?_limit=25&_start=${page}&_sort=createdAt:DESC`)
      this.mensajes = data.map(i => {
        return {
          ...i,
          fecha_inicio: dayjs(i.fecha_inicio).format('YYYY-MM-DDTHH:mm'),
          fecha_fin: dayjs(i.fecha_fin).format('YYYY-MM-DDTHH:mm'),
          inicio: dayjs(i.fecha_inicio).format('DD-MM-YYYY HH:mm'),
          fin: dayjs(i.fecha_fin).format('DD-MM-YYYY HH:mm')
        }
      })
    },
    editMensaje (id) {
      this.selected = this.mensajes.find(i => i.id === id)
      this.showEdit = true
    },
    async deleteMensaje (id) {
      if (window.confirm('¿Estas seguro de borrar el registro?')) {
        await this.$http.mensajes.delete(`/${id}`)
        this.getMensajes()
        this.getPages()
      }
    },
    refresh () {
      this.showEdit = false
      this.showAdd = false
      this.getMensajes()
      this.getPages()
    }
  }
}
</script>
